/* app/js/src/components/datePicker/datepicker.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.datepicker {
  position: relative;
  display: inline-block;
  color: #2b2b2b;
  font-family: "Open Sans", sans-serif;
}
.datepicker__calendar {
  overflow: hidden;
  z-index: 1000;
  top: 1.9em;
  left: 0;
  height: auto;
  width: 250px;
  font-size: 14px;
  background-color: #ffffff;
  cursor: default;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.datepicker__calendar__content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-flow: wrap;
  flex-flow: wrap;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-top: 0.2em;
}
.datepicker__calendar__label {
  display: inline-block;
  width: 3.49em;
  height: 2.2em;
  line-height: 2.2em;
  text-align: center;
  color: #879baf;
  font-size: 10px;
  text-transform: uppercase;
}
.datepicker__calendar__month {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-flow: wrap;
  flex-flow: wrap;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.datepicker__calendar__month__day {
  display: inline-block;
  width: 2.2em;
  height: 2em;
  font-size: 16px;
  line-height: 2.2em;
  text-align: center;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 0.2px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.datepicker__calendar__month__day.weekend {
  color: #879baf !important;
}
.datepicker__calendar__month__day:focus {
  outline: none;
}
.datepicker__calendar__nav {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  width: 250px;
  height: 35px;
  background-color: #eef2f6;
}
.datepicker__calendar__nav__arrow {
  padding: 0 1.04em;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.datepicker__calendar__nav__arrow:hover {
  -ms-transform: scale(1.05);
  -webkit-transform: scale(1.05);
  transform: scale(1.05);
}
.datepicker__calendar__nav__chevron {
  fill: #879baf;
  transition: 0.37s;
  height: 0.7em;
  width: 0.43em;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.datepicker__calendar__nav__chevron:hover {
  fill: #232f3a;
}
.datepicker__calendar__nav__header {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: center;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #7d8fa1;
  text-transform: uppercase;
}
.datepicker__input {
  position: absolute;
  top: -1000px;
}
/*# sourceMappingURL=datepicker.component.css.map */
